import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AlertDialogComponent, AlertDialogData, AlertType } from '../../view-layer/components/alert-dialog.component';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface AlertOptions {
  title?: string;
  message?: string;
  text?: string;
  type?: AlertType;
  icon?: AlertType;
  confirmButtonText?: string;
  showCancelButton?: boolean;
  cancelButtonText?: string;
}

export interface ConfirmOptions extends AlertOptions {
  confirmButtonText?: string;
  cancelButtonText?: string;
}

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  constructor(private dialog: MatDialog) {}

  show(options: AlertOptions): Observable<boolean> {
    const data: AlertDialogData = {
      title: options.title,
      message: options.message ?? options.text,
      text: options.text ?? options.message,
      type: options.type ?? options.icon ?? 'info',
      confirmButtonText: options.confirmButtonText,
      showCancelButton: options.showCancelButton,
      cancelButtonText: options.cancelButtonText,
    };
    const ref = this.dialog.open(AlertDialogComponent, {
      width: 'min(440px, 92vw)',
      maxWidth: '95vw',
      maxHeight: '90vh',
      disableClose: false,
      data,
    });
    return ref.afterClosed();
  }

  /**
   * Окно с двумя кнопками (Отмена / Подтвердить). Возвращает true при подтверждении, false при отмене.
   */
  confirm(options: ConfirmOptions): Observable<boolean> {
    return this.show({
      ...options,
      showCancelButton: true,
      type: options.type ?? 'warning',
    }).pipe(
      map((v) => v === true)
    );
  }

  error(title: string, message?: string, confirmButtonText?: string): Observable<boolean> {
    return this.show({ title, message, type: 'error', confirmButtonText });
  }

  success(title: string, message?: string, confirmButtonText?: string): Observable<boolean> {
    return this.show({ title, message, type: 'success', confirmButtonText });
  }

  warning(title: string, message?: string, confirmButtonText?: string): Observable<boolean> {
    return this.show({ title, message, type: 'warning', confirmButtonText });
  }

  info(title: string, message?: string, confirmButtonText?: string): Observable<boolean> {
    return this.show({ title, message, type: 'info', confirmButtonText });
  }
}
